module.exports = __webpack_public_path__ + "img/logo-header.871182ea.svg";